import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useMemo,
  useCallback,
} from "react";
import { CreditSearchContext } from "./creditSearch";
import { useLocation, useNavigate ,useParams} from "react-router-dom";
import { Navbar_1 } from "../../UiComponents";
import SidebarDD from "./SideBar/SidebarDD";
import Preview from "./Preview/Preview";
import CardPreview from "./Cards/CardPreview";
import Options from "./Options/Options";
import Footer from "./Footer/Footer";
import "./Project.css";
import "../WNewUserTutorials/PopupBoxStyle.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Components/CustomToast/CustomToast.css";
import CustomToast, {
  customToatStyle,
  customToatStyleError,
} from "../../Components/CustomToast/CustomToast";

import { Scrollx_animate } from "../../assets/icons";
import { getCurrentNotification } from "../utils/global";

import { useSelector, useDispatch } from "react-redux";
import {
  getDefalutLogos,
  getProjectDetails,
  fetchUserFonts,
  resetProject,
  saveProjectSettings,
  updateSettingOptionState,
  updateProjectStatus,
  updateProjectCreditsByGoogle,
} from "../../Redux/actions/projectActions";
import {
  getCurrentPlan,
  getNotification,
  addNotifications,
  getUserAllInformation,
} from "../../Redux/actions/commonActtion";
import {
  getApiFontUrl,
  injectFontFaceFromUrl,
} from "./Options/OptionFont/FontComponent/fontFaceUtils";
import { getRenderCnt } from "../../Redux/actions/authActions";
import { markProjectOpened } from "../../Redux/actions/projectsActions";
import CreditsIntro from "./CreditsIntro/CreditsIntro";
import ProjectUnavailableModal from "./ProjectUnavailableModal";
import { isProjectUnavailableResponse } from "./projectAvailability";
import { scheduleProjectSave } from "./projectSaveCoordinator";
import { useCreditBlockGeometryWarnings } from "./useCreditBlockOverlapWarnings";
import {
  exitDocumentFullscreen,
  isDocumentFullscreen,
  requestElementFullscreen,
} from "./fullscreenUtils";
import useResetRenderedStatusOnEdit from "./useResetRenderedStatusOnEdit";

const hasUnfinishedRender = (renders) =>
  Array.isArray(renders) &&
  renders.some((render) => render && render.isRederFinished === false);

const EMPTY_BLOCK_INDEXES = new Set();

export default function Project() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // Derive isCard from the route so a refresh or direct link to
  // /dashboard/card/:projectId always loads the card endpoints,
  // regardless of stale localStorage / missing router state.
  const isCard = /\/dashboard\/card(\/|$)/.test(location.pathname);
  const isRenderPage = location.pathname.endsWith("/render");
  const isEditorEntry = /^\/dashboard\/(scroll|card)\/[^/]+\/?$/.test(
    location.pathname,
  );
  const [isRenderExport, setIsRenderExport] = useState(false);
  const { projectId } = useParams();
  const [isTitleSafe, setIsTitleSafe] = useState(true);
  const [isScrBound, setIsScrBound] = useState(false);
  const [aspectRatio_FrameSize, setAspectRatio_FrameSize] = useState("Class1x78");
  const [reLoading, setReLoading] = useState({ condn: false, label: "" });
  const [selectRatio, setSelectRatio] = useState(false);
  const [savedSaving, setSavedSaving] = useState("");
  const isRederFinished = useSelector(
    (state) => state.commonReducer.isRederFinished
  );
  const accountUser = useSelector(
    (state) => state?.commonReducer?.userData?.[0],
  );
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [loadOnProjectFetch, setLoadOnProjectFetch] = useState(true);
  const [isProjectUnavailable, setIsProjectUnavailable] = useState(false);
  const millisecondsToWait = 1 * 60 * 1000;

  const [isDisplayTitle, setIsDisplayTitle] = useState(true);

  // Keep localStorage in sync for older code paths that still read it
  useEffect(() => {
    localStorage.setItem("isCard", JSON.stringify(Boolean(isCard)));
  }, [isCard]);

  useEffect(() => {
    if (isEditorEntry && projectId) {
      dispatch(markProjectOpened(projectId, isCard));
    }
  }, [dispatch, isCard, isEditorEntry, projectId]);

  useEffect(() => {
    // SyncProject();
    getAllDefaultLogos();
  }, []);

  const getAllDefaultLogos = async () => dispatch(getDefalutLogos());

  const SyncProject = async () => {
    const res = await dispatch(getProjectDetails(projectId, isCard));
    dispatch(getCurrentPlan());
    return res;
  };

  const fetchProjectDetails = async () => {
    setLoadOnProjectFetch(true);
    try {
      // Fetch in parallel: the project and font list are independent, and a
      // font failure should not block the editor.
      const [res, fontsResp] = await Promise.all([
        dispatch(getProjectDetails(projectId, isCard)),
        // Preload and inject custom fonts so preview renders with correct typography.
        dispatch(fetchUserFonts()).catch(() => null),
      ]);
      if (isProjectUnavailableResponse(res)) {
        setIsProjectUnavailable(true);
        return res;
      }
      const fonts =
        fontsResp?.fonts ||
        fontsResp?.data?.fonts ||
        (Array.isArray(fontsResp) ? fontsResp : []);

      if (Array.isArray(fonts) && fonts.length) {
        fonts.forEach(({ fontFamily, proxyUrl }) => {
          injectFontFaceFromUrl(
            fontFamily,
            getApiFontUrl(proxyUrl),
          );
        });
      }

      dispatch(getCurrentPlan());
      return res;
    } catch (err) {
      alert("Something went wrong");
    } finally {
      setLoadOnProjectFetch(false);
    }
  };

  const fetchRenderCnt = () => {
     dispatch(getRenderCnt());
  }


  const customFonts = useSelector((state) => state?.project?.customFonts ?? []);

  // Keep custom uploaded fonts available as soon as the project loads.
  useEffect(() => {
    if (!customFonts?.length) return;
    customFonts.forEach(({ fontFamily, proxyUrl }) => {
      injectFontFaceFromUrl(fontFamily, getApiFontUrl(proxyUrl));
    });
  }, [customFonts]);

  const getBlockSize = (asd, val) => {
    setAspectRatio_FrameSize(val);
    switch (val) {
      case "hdClass":
        return setAspectRatio_FrameSize(val);

      case "fhdClass":
        return setAspectRatio_FrameSize(val);

      case "qhdClass":
        return setAspectRatio_FrameSize(val);

      default:
        return "deafult";
    }
  };

  

  const projectData = useSelector((state) => state.project);

  // The store can still hold the last project opened. Clear it before paint
  // so the editor never shows, or acts on, another project while this loads.
  const hasStaleProject =
    Boolean(projectData?._id) && String(projectData._id) !== String(projectId);
  useLayoutEffect(() => {
    if (hasStaleProject) dispatch(resetProject());
    // Mount only, like the fetch below; afterwards the store holds this project.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // A finished-render toast only makes sense for a render this same
    // project already had in progress, so check before the fetch replaces it.
    const hadUnfinishedRender =
      !hasStaleProject && hasUnfinishedRender(projectData?.renders);
    fetchProjectDetails().then((res) => {
      if (hadUnfinishedRender) notifyIfRenderFinished(res);
    });
    fetchRenderCnt();
  }, []);
  const resetRenderedStatusToDraft = useCallback(() => {
    if (!projectData?._id) return;
    dispatch(updateProjectStatus(projectData._id, "Draft", 0, isCard));
  }, [dispatch, isCard, projectData?._id]);

  useResetRenderedStatusOnEdit({
    enabled: isEditorEntry,
    project: projectData,
    onReset: resetRenderedStatusToDraft,
  });

  const handlePreviewGuidesChange = (previewGuides) => {
    dispatch(updateSettingOptionState("preview_guides", previewGuides));
    if (!projectData?._id) return;
    const settings = {
      ...projectData.settings,
      preview_guides: previewGuides,
    };
    const saveContext = {
      projectId: projectData._id,
      isCard: projectData.isCard,
    };
    scheduleProjectSave(
      `project-settings-guides:${projectData._id}`,
      () => dispatch(saveProjectSettings(settings, saveContext)),
      350,
    );
  };
  const creditSheetUrl =
    projectData?.googleSheetLink ||
    (projectData?.googleSpreadSheetId
      ? `https://docs.google.com/spreadsheets/d/${projectData.googleSpreadSheetId}`
      : null);

  const openCreditSheet = () => {
    if (!creditSheetUrl) return;
    window.open(creditSheetUrl, "_blank", "noopener,noreferrer");
  };

  const syncCreditsFromSidebar = async () => {
    if (
      reLoading?.condn ||
      !projectData?._id ||
      !projectData?.googleSpreadSheetId
    ) {
      return;
    }

    setReLoading({ condn: true, label: "Syncing..." });
    try {
      const result = await dispatch(
        updateProjectCreditsByGoogle(
          projectData._id,
          projectData.googleSpreadSheetId,
          projectData.credits,
          isCard,
        ),
      );

      if (result?.success === true) {
        toast(
          <CustomToast title="" content={result?.message} />,
          customToatStyle,
        );
      } else {
        toast(
          <CustomToast
            isError
            title={result?.response?.data?.title || "Unable to sync credits"}
            content={
              result?.response?.data?.message ||
              "Please try syncing the Credit Sheet again."
            }
          />,
          customToatStyleError,
        );
      }
    } catch (_error) {
      toast(
        <CustomToast
          isError
          title="Unable to sync credits"
          content="Please try syncing the Credit Sheet again."
        />,
        customToatStyleError,
      );
    } finally {
      setReLoading({ condn: false, label: "" });
    }
  };

  const [creditSearchQuery, setCreditSearchQuery] = useState("");
  const blocks = useMemo(
    () =>
      projectData?.credits?.map((credit) => ({
        block_name: credit?.options?.block_name,
        block_type: credit?.options?.block_type,
        _id: credit._id,
        heading: credit?.options?.heading,
        subheading: credit?.options?.subheading,
        items: credit.items,
      })),
    [projectData?.credits],
  );

  const overlapRevision = useMemo(
    () => ({
      credits: projectData?.credits,
      fontStyle: projectData?.fontStyle,
      settings: projectData?.settings,
    }),
    [projectData?.credits, projectData?.fontStyle, projectData?.settings],
  );

  const {
    overlappingBlockIndexes,
    gutterOverflowingBlockIndexes,
    titleSafeOverflowingBlockIndexes,
  } = useCreditBlockGeometryWarnings({
    enabled:
      !isRenderPage &&
      !isRenderExport &&
      !loadOnProjectFetch &&
      Boolean(projectData?.credits?.length),
    revision: overlapRevision,
    targetKey: `${isCard ? "card" : "scroll"}:${projectId || ""}`,
  });
  const [overflowingCardBlockIndexes, setOverflowingCardBlockIndexes] =
    useState(() => new Set());

  useEffect(() => {
    setOverflowingCardBlockIndexes((current) =>
      current.size ? new Set() : current,
    );
  }, [isCard, projectId]);

  const currentBlockId = projectData?.currentBlock?.id;

  const currentBlockIdx = projectData?.credits?.findIndex(
    (credit) => credit._id === currentBlockId
  );

  const currentBlockOptions = ![undefined, -1].includes(currentBlockIdx)
    ? projectData?.credits[currentBlockIdx]?.options
    : {};

  const { previewWidth } = useSelector((state) => state?.application);



  // Card preview width follows the selected resolution's aspect ratio
  // (e.g. 1920x1080 -> 16:9, 1920x1440 -> 4:3). Base height 450px keeps
  // 16:9 at the previous 800px; other ratios scale from the same height.
  const CARD_PREVIEW_HEIGHT = 450;
  const cardAspectRatio =
    projectData?.resolution?.videoWidth && projectData?.resolution?.videoHeight
      ? projectData.resolution.videoWidth / projectData.resolution.videoHeight
      : 16 / 9;
  const cardPreviewWidth = `${Math.round(CARD_PREVIEW_HEIGHT * cardAspectRatio)}px`;


  async function notifyIfRenderFinished(res) {
    const result = res?.data?.project?.renders;
    if (result && !hasUnfinishedRender(result)) {
      toast(
        <CustomToast
          title=""
          content={
            "Your export has been completed! Please check the render page and proceed to download."
          }
        />,
        customToatStyle
      );
      const noti = getCurrentNotification();

      const payload = {
        project_id: noti.project_id,
        render_id: noti.render_id,
        message: `Render in progress ${noti.details.videoFilename}`,
        status: 1,
        user_id: noti.user_id,
      };

      await dispatch(addNotifications(payload));
      await dispatch(getNotification({ page_no: 1, limit: 0 }));
      return;
    }
  }

  // useEffect(() => {
  //   let timer = setInterval(renderRandomCall, millisecondsToWait);
  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);

  useEffect(() => {
    dispatch(getNotification({ page_no: 1, limit: 0 }));
  }, []);

  // Function to handle fullscreen change
  const onFullscreenChange = () => {
    setIsFullscreen(isDocumentFullscreen(document));
  };
  // Effect to add and clean up fullscreen change event listeners
  useEffect(() => {
    document.addEventListener("fullscreenchange", onFullscreenChange);
    document.addEventListener("mozfullscreenchange", onFullscreenChange); // Firefox
    document.addEventListener("webkitfullscreenchange", onFullscreenChange); // Chrome, Safari, and Opera
    document.addEventListener("msfullscreenchange", onFullscreenChange); // IE/Edge
    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener("fullscreenchange", onFullscreenChange);
      document.removeEventListener("mozfullscreenchange", onFullscreenChange);
      document.removeEventListener(
        "webkitfullscreenchange",
        onFullscreenChange
      );
      document.removeEventListener("msfullscreenchange", onFullscreenChange);
    };
  }, []);

  // Function to enter fullscreen mode
  const enterFullscreen = async () => {
    const previewContainer = document.getElementById("preview-container");
    const enteredFullscreen = await requestElementFullscreen(previewContainer);
    if (!enteredFullscreen) {
      toast(
        <CustomToast
          isError
          title="Fullscreen unavailable"
          content="Your browser did not allow fullscreen mode."
        />,
        customToatStyleError,
      );
    }
  };

  const exitFullscreen = async () => {
    const exitedFullscreen = await exitDocumentFullscreen(document);
    if (!exitedFullscreen && isDocumentFullscreen(document)) {
      toast(
        <CustomToast
          isError
          title="Unable to exit fullscreen"
          content="Please press Escape to leave fullscreen mode."
        />,
        customToatStyleError,
      );
    }
  };

  const handleFooterClick = () => {
    if (isFullscreen) {
      exitFullscreen();
    } else {
      enterFullscreen();
    }
  };

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );

  return (
    <>
      <ToastContainer closeButton={CloseButton} newestOnTop />

      <CreditsIntro
        active={isEditorEntry}
        entryKey={location.pathname}
        accountUser={accountUser}
        projectId={projectId}
        projectEligible={projectData?.creditsIntroEligible === true}
        creditSheetUrl={projectData?.googleSheetLink}
      />

      {/* {createPortal(
        <ToastContainer closeButton={CloseButton} newestOnTop />,
        document.body
      )} */}

      <ProjectUnavailableModal isOpen={isProjectUnavailable} />

      {loadOnProjectFetch && (
        <div className="modal-overlayLoader ">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80 LoadOnProjectimg"
            width="120px"
            height="120px"
          />
        </div>
      )}

      {reLoading?.condn ? (
        <div className="modal-overlayLoader">
          <img
            src={Scrollx_animate}
            className="absolute opacity-80"
            width="120px"
            height="120px"
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Syncing...</p>
        </div>
      ) : null}

      <div className="wlcmProjectContainer">
        <div className="projectContainer">
          
          <div className="projectHead">
            <Navbar_1 />
          </div>

          <CreditSearchContext.Provider value={creditSearchQuery}>
          <div className="projectBody">
            <div className="sideNav">
              <SidebarDD
                currentBlockId={currentBlockId}
                blocks={blocks}
                projectData={projectData}
                searchQuery={creditSearchQuery}
                setSearchQuery={setCreditSearchQuery}
                creditSheetUrl={creditSheetUrl}
                canSyncCredits={Boolean(
                  projectData?._id && projectData?.googleSpreadSheetId,
                )}
                isSyncing={reLoading?.condn}
                onSyncCredits={syncCreditsFromSidebar}
                overlappingBlockIndexes={overlappingBlockIndexes}
                gutterOverflowingBlockIndexes={gutterOverflowingBlockIndexes}
                titleSafeOverflowingBlockIndexes={
                  titleSafeOverflowingBlockIndexes
                }
                overflowingBlockIndexes={
                  isCard ? overflowingCardBlockIndexes : EMPTY_BLOCK_INDEXES
                }
              />
            </div>

            <div
              className={
                "preview" + (isRenderPage ? " is-render-page-hidden" : "")
              }
              id="preview-container"
              style={{
                // backgroundColor: "#080808",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                flexGrow: 1,
                borderRadius: "0 0 10px 10px",
              }}
            >
              <div
                className={"scrollFrame " + (
                  isCard
                    ? isFullscreen
                      ? "w-full h-full"
                      : "h-[100%]  RespPreviewClass"
                    : isFullscreen
                    ? aspectRatio_FrameSize === "Class1x33"
                      ? "Class1x33Preview"
                      : aspectRatio_FrameSize === "Class2x39"
                      ? "Class2x39Preview"
                      : aspectRatio_FrameSize === "Class1x78"
                      ? "Class1x78Preview"
                      : aspectRatio_FrameSize === "Class1x85"
                      ? "Class1x85Preview"
                      : aspectRatio_FrameSize === "Class1x9"
                      ? "Class1x9Preview"
                      : aspectRatio_FrameSize === "Class2_35x1"
                      ? "Class2_35x1Preview"
                      : "w-full h-full"
                    : aspectRatio_FrameSize === "Class1x33"
                    ? "Class1x33"
                    : aspectRatio_FrameSize === "Class2x39"
                    ? "Class2x39"
                    : aspectRatio_FrameSize === "Class1x78"
                    ? "Class1x78"
                    : aspectRatio_FrameSize === "Class1x85"
                    ? "Class1x85"
                    : aspectRatio_FrameSize === "Class1x9"
                    ? "Class1x9"
                    : aspectRatio_FrameSize === "Class2_35x1"
                    ? "Class2_35x1"
                    : "h-[100%]  RespPreviewClass"
                )}
                style={{
                   width: isCard ? cardPreviewWidth : "",
                  // borderLeft: !isCard && isTitleSafe ? "2px dashed #373843" : "",
                  // borderRight: !isCard && isTitleSafe ? "2px dashed #373843" : "",
                }}
              >
                {!isCard && (
                  <Preview
                    projectData={projectData}
                    isFullscreen={isFullscreen}
                    onFullscreenToggle={handleFooterClick}
                    isRenderExport={isRenderExport}
                    setIsRenderExport={setIsRenderExport}
                    isTitleSafe={isTitleSafe}
                    onTitleSafeChange={setIsTitleSafe}
                    aspectRatio_FrameSize={aspectRatio_FrameSize}
                    previewGuides={projectData?.settings?.preview_guides}
                    onPreviewGuidesChange={handlePreviewGuidesChange}
                    canOpenCreditSheet={Boolean(creditSheetUrl)}
                    canSyncCredits={Boolean(
                      projectData?._id && projectData?.googleSpreadSheetId,
                    )}
                    isSyncingCredits={reLoading?.condn}
                    onOpenCreditSheet={openCreditSheet}
                    onSyncCredits={syncCreditsFromSidebar}
                  />
                )}
                {isCard && (
                  <CardPreview
                    projectData={projectData}
                    isFullscreen={isFullscreen}
                    exitFullscreen={exitFullscreen}
                    isDisplayTitle={isDisplayTitle}
                    isRenderExport={isRenderExport}
                    setIsRenderExport={setIsRenderExport}
                    blocks={blocks}
                    onOverflowBlockIndexesChange={
                      setOverflowingCardBlockIndexes
                    }
                  />
                )}
              </div>
              {/* <div className="projectFooter">
            <Footer
              setReLoading={setReLoading}
              currentBlockOptions={currentBlockOptions}
              isTitleSafe={isTitleSafe}
              setIsTitleSafe={setIsTitleSafe}
              isScrBound={isScrBound}
              setIsScrBound={setIsScrBound}
              selectRatio={selectRatio}
              setSelectRatio={setSelectRatio}
              getBlockSize={getBlockSize}
              aspectRatio_FrameSize={aspectRatio_FrameSize}
              setAspectRatio_FrameSize={setAspectRatio_FrameSize}
              handleFooterClick={handleFooterClick}
              isCard={isCard}
              isDisplayTitle={isDisplayTitle}
              setIsDisplayTitle={setIsDisplayTitle}
              isRenderExport={isRenderExport}
              setIsRenderExport={setIsRenderExport}
            />
          </div> */}
            </div>

            <div className="options">
              <Options
                currentBlockOptions={currentBlockOptions}
                currentBlockIdx={currentBlockIdx}
                currentBlockId={currentBlockId}
                setReLoading={setReLoading}
                isCard={isCard}
                setIsRenderExport={setIsRenderExport}
                aspectRatio_FrameSize={aspectRatio_FrameSize}
                setAspectRatio_FrameSize={setAspectRatio_FrameSize}
              />
            </div>
             <div className="projectFooter">
            <Footer
              setReLoading={setReLoading}
              currentBlockOptions={currentBlockOptions}
              isTitleSafe={isTitleSafe}
              setIsTitleSafe={setIsTitleSafe}
              isScrBound={isScrBound}
              setIsScrBound={setIsScrBound}
              selectRatio={selectRatio}
              setSelectRatio={setSelectRatio}
              getBlockSize={getBlockSize}
              aspectRatio_FrameSize={aspectRatio_FrameSize}
              setAspectRatio_FrameSize={setAspectRatio_FrameSize}
              handleFooterClick={handleFooterClick}
              isCard={isCard}
              isDisplayTitle={isDisplayTitle}
              setIsDisplayTitle={setIsDisplayTitle}
              isRenderExport={isRenderExport}
              setIsRenderExport={setIsRenderExport}
              onPreviewGuidesChange={handlePreviewGuidesChange}
            />
          </div>
          </div>
          </CreditSearchContext.Provider>
        </div>

        
      </div>
    </>
  );
}
